module.exports = __webpack_public_path__ + "b453e1c7c1f1ed2a304258d5ef6e5971.woff";


//////////////////
// WEBPACK FOOTER
// ./libs/font-awesome/webfonts/fa-brands-400.woff
// module id = 345
// module chunks = 0